type ReadyFileParams = { name: string, size: number, id: number }

const ReadyFile = ({ name, size, id }: ReadyFileParams) => ({
  name(): string {
    return name
  },
  size(): string {
    return size.toFixed(2)
  },
  type: 'ready' as const,
  id
})

export default ReadyFile

export type { ReadyFileParams }
